<template>
  <div class="col-12 mt-4 overall-section">
    <DottedLineHeader :text="$t('more.result_history')">
      <RadioButtonGroup v-if="!printing" class="col-md-6" name="bp-stats-overall-filter" :items="timeRangeLabels" :values="timeRangeKeys" @valueChanged="filterValueChanged" style="display: block;"/>
      <span v-if="printing" class="mb-3" style="display: block;">{{$t("more.selected_time_range")}} <span class="selected-time-range">{{$t(timeRangeLabels[timeRangeKeys.indexOf(selectedTimeRange)])}}</span></span>
    </DottedLineHeader>

    <Loading v-if="bpTestSummaryLoading"/>
    <Error v-if="bpTestSummaryLoadError && bpTestSummaryLoadError.status !== 404"/>
    <NoData v-if="(bpTestSummary && bpTestSummary.length === 0) || (bpTestSummaryLoadError && bpTestSummaryLoadError.status === 404)"/>

    <div v-if="bpTestSummary && bpTestSummary.length > 0 && !bpTestSummaryLoading && !bpTestSummaryLoadError">
      <template v-for="(title, index) in chartTitles">
        <hr v-if="index > 0" :key="title + '-hr'" class="mt-4 mb-4 dotted-line tm15 col-6 over-section-hr" />
        <span :key="title + '-title'" class="overall-section-title">{{$t(title)}}</span>
        <GradientChart :key="title + '-chart'" :chartId="chartIds[index]" :title="chartTooltips[index]" :printing="printing" :chartData="data[index]" :chartLabels="labels" :color2="themes.chartMaxColor" :color1="themes.chartMinColor"/>
        <div :key="title + '-footer'" class="row">
          <StatisticsTable class="col-md-6 overall-section-table" style="margin: 0 auto;" :data="data[index]"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import StatisticsTable from '@/components/StatisticsTable.vue'
import DottedLineHeader from '@/components/DottedLineHeader.vue'
import GradientChart from '@/components/GradientChart.vue'
import RadioButtonGroup from '@/components/RadioButtonGroup.vue'
import Loading from '@/components/Loading.vue'
import Error from '@/components/Error.vue'
import NoData from '@/components/NoData.vue'

export default {
  components: {
    StatisticsTable,
    DottedLineHeader,
    GradientChart,
    RadioButtonGroup,
    Loading,
    Error,
    NoData
  },
  data: () => ({
    chartTitles: [
      'more.sys',
      'more.dia',
      'more.hb_rate'
    ],
    chartTooltips: [
      'SYS', 'DIA', 'HR'
    ],
    chartIds: [
      'overall-sys-chart',
      'overall-dia-chart',
      'overall-hr-chart'
    ],
    timeRangeKeys: [
      '7',
      '30',
      '90'
    ],
    timeRangeLabels: [
      'filter.last7',
      'filter.last30',
      'filter.last90'
    ],
    selectedTimeRange: '7'
  }),
  props: {
    sharedTest: Object,
    printing: Boolean
  },
  computed: {
    ...mapState({
      bpTestSummary: state => state.test.summary.item,
      bpTestSummaryLoading: state => state.test.summary.loading,
      bpTestSummaryLoadError: state => state.test.summary.error
    }),
    data () {
      if (!this.bpTestSummary) {
        return null
      }
      var data = []
      var sysData = []
      var diaData = []
      var hrData = []

      this.bpTestSummary.forEach(sm => {
        sysData.push(sm.sys)
        diaData.push(sm.dia)
        hrData.push(sm.hr)
      })

      data.push(sysData)
      data.push(diaData)
      data.push(hrData)
      return data
    },
    labels () {
      if (!this.bpTestSummary) {
        return null
      }
      var data = []
      this.bpTestSummary.forEach(sm => {
        data.push(sm.tested_at)
      })
      return data
    }
  },
  methods: {
    ...mapActions('test', ['testSummary']),
    loadData (days) {
      var from = Math.floor(Date.now() / 1000) - (days * 86400)
      this.testSummary({patientUuid: this.sharedTest.user.uuid, context: 'doctor', fromDate: from})
    },
    filterValueChanged: function (time) {
      this.selectedTimeRange = time
      var days = parseInt(time)
      this.loadData(days)
    }
  },
  mounted () {
    this.loadData(7)
  }
}
</script>

<style>
.overall-section {
  text-align: center;
}
.overall-section-title {
  font-weight: bold;
  display: inline-block;
}
.over-section-hr {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/BloodPressureResultsOverall.vue